import { Widget } from "@rjsf/utils";

import { LimitedCheckboxWidget } from "./LimitedCheckboxWidget";
import { TitleWidget } from "./TitleWidget";
import { ParagraphWidget } from "./ParagraphWidget";
import { SubtitleWidget } from "./SubtitleWidget";
import { MarkdownTextWidget } from "./MarkdownTextWidget";

interface WidgetRegistry {
  [name: string]: Widget;
}

export const Widgets: WidgetRegistry = {
  limitedCheckbox: LimitedCheckboxWidget,
  title: TitleWidget,
  subtitle: SubtitleWidget,
  paragraph: ParagraphWidget,
  markdownText: MarkdownTextWidget
};
